import { useState } from "react";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { classList, sectionList, subjectList } from "../../utils";
import { server } from "../../server";
import { getSession } from "../../functions";

function AddExaminationDetails() {
  const session = getSession();

  const initialState = {
    term: "",
    class: "",
    section: [],
    stream: "",
    oral: [],
    written: [],
    dictation: [],
    notes: [""],
    result: [""],
    oralExaminationTime: "",
    writtenExaminationTime: "",
    dictationExaminationTime: "",
  };

  const STREAM_OPTIONS = ["Science", "Commerce", "Humanities"];

  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // ✅ Reset form
  const resetForm = () => {
    setFormData(initialState);
  };

  // ✅ Generic input handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Add dynamic row
  const handleAddRow = (field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: [
        ...prev[field],
        field === "notes" || field === "result"
          ? ""
          : { time: "", day: "", date: "", subject: "" },
      ],
    }));
  };

  // ✅ Remove dynamic row
  const handleRemoveRow = (field, index) => {
    setFormData((prev) => {
      const updated = [...prev[field]];
      updated.splice(index, 1);
      return { ...prev, [field]: updated };
    });
  };

  // ✅ Handle array field updates
  const handleArrayChange = (field, index, key, value) => {
    setFormData((prev) => {
      const updated = [...prev[field]];
      if (field === "notes" || field === "result") {
        updated[index] = value;
      } else {
        updated[index][key] = value;
      }
      return { ...prev, [field]: updated };
    });
  };

  // ✅ Submit API
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const currentSession = getSession();
      const url = `${server}/AddAdmitCardDataForParticularClass`;
      const payload = {
        ...formData,
        session: currentSession,
      };
      await axios.post(url, payload, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      toast.success("Examination Details Added", {
        position: "top-right",
      });

      resetForm();
      navigate("/admit-card");
    } catch (error) {
      toast.error("Failed to Add Examination Details", {
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12">
                  <div class="m-3 mt-2 pt-1 d-flex justify-content-between">
                    <div class="d-flex align-items-center mt-2">
                      <span
                        onClick={() => window.history.back()}
                        class="back-button me-3 cursor-pointer"
                      >
                        <i className="bi bi-arrow-left fs-3"></i>
                      </span>
                      <nav aria-label="breadcrumb">
                        <h4 className="m-0 lh-sm">Add Examination Details</h4>
                        <ol class="breadcrumb pe-3 lh-sm">
                          <li class="breadcrumb-item">
                            <a href="#">Admit Card</a>
                          </li>
                          <li
                            class="breadcrumb-item active"
                            aria-current="page"
                          >
                            Add Examination Details
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="container-fluid">
              <div className="row g-2">
                <div className="col-lg-8">
                  <form onSubmit={handleSubmit}>
                    <div class="px-5 py-3 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingOne">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-controls="collapseOne"
                            >
                              <span class="me-auto fs-5">
                                1. General Information{" "}
                                <span className="ms-3 text-secondary">
                                  (02/05)
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span className="badge me-5 px-3 bg-danger-soft">
                                  Required
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseOne"
                            class="collapse"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              <div className="col-md-6">
                                <label className="form-label mb-1">
                                  Session <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="session"
                                  className="form-control"
                                  value={formData.session}
                                  placeholder="Enter Session"
                                  readOnly
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1">
                                  Examination Name{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <Select
                                  name="term"
                                  value={
                                    [
                                      {
                                        label: "Half Yearly Examination",
                                        value: "Half Yearly Examination",
                                      },
                                      {
                                        label: "Annual Examination",
                                        value: "Annual Examination",
                                      },
                                    ].find(
                                      (opt) => opt.value === formData.term,
                                    ) || null
                                  }
                                  onChange={(selected) =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      term: selected?.value || "",
                                    }))
                                  }
                                  options={[
                                    {
                                      label: "Half Yearly Examination",
                                      value: "Half Yearly Examination",
                                    },
                                    {
                                      label: "Annual Examination",
                                      value: "Annual Examination",
                                    },
                                  ]}
                                  placeholder="Select Examination"
                                  classNamePrefix="react-select"
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1">
                                  Class <span className="text-danger">*</span>
                                </label>
                                <Select
                                  name="class"
                                  value={
                                    classList
                                      .map((cls) => ({
                                        label: cls,
                                        value: cls,
                                      }))
                                      .find(
                                        (opt) => opt.value === formData.class,
                                      ) || null
                                  }
                                  onChange={(selected) => {
                                    const newClass = selected?.value || "";
                                    setFormData((prev) => ({
                                      ...prev,
                                      class: newClass,
                                      stream: ["XI", "XII"].includes(newClass)
                                        ? prev.stream
                                        : "",
                                    }));
                                  }}
                                  options={classList.map((cls) => ({
                                    label: cls,
                                    value: cls,
                                  }))}
                                  placeholder="Select Class"
                                />
                              </div>
                              <div className="col-md-6">
                                <label className="form-label mb-1">
                                  Section <span className="text-danger">*</span>
                                </label>
                                <Select
                                  isMulti
                                  name="section"
                                  options={[
                                    { label: "Select All", value: "all" },
                                    ...sectionList.map((sec) => ({
                                      label: sec,
                                      value: sec,
                                    })),
                                  ]}
                                  value={(formData.section || []).map(
                                    (sec) => ({
                                      label: sec,
                                      value: sec,
                                    }),
                                  )}
                                  onChange={(selected) => {
                                    if (!selected) {
                                      setFormData((prev) => ({
                                        ...prev,
                                        section: [],
                                      }));
                                      return;
                                    }
                                    if (
                                      selected.some(
                                        (opt) => opt.value === "all",
                                      )
                                    ) {
                                      setFormData((prev) => ({
                                        ...prev,
                                        section: [...sectionList],
                                      }));
                                    } else {
                                      setFormData((prev) => ({
                                        ...prev,
                                        section: selected.map(
                                          (opt) => opt.value,
                                        ),
                                      }));
                                    }
                                  }}
                                  placeholder="Select Section(s)"
                                  classNamePrefix="react-select"
                                />
                              </div>
                              {["XI", "XII"].includes(formData.class) && (
                                <div className="col-md-6">
                                  <label className="form-label mb-1">
                                    Stream{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <Select
                                    name="stream"
                                    value={
                                      STREAM_OPTIONS.map((s) => ({
                                        label: s,
                                        value: s,
                                      })).find(
                                        (opt) => opt.value === formData.stream,
                                      ) || null
                                    }
                                    onChange={(selected) =>
                                      setFormData((prev) => ({
                                        ...prev,
                                        stream: selected?.value || "",
                                      }))
                                    }
                                    options={STREAM_OPTIONS.map((s) => ({
                                      label: s,
                                      value: s,
                                    }))}
                                    placeholder="Select Stream"
                                    classNamePrefix="react-select"
                                  />
                                </div>
                              )}
                              <div className="col-md-6">
                                <label className="form-label mb-1">
                                  Oral Examination Time
                                </label>
                                <input
                                  type="text"
                                  name="oralExaminationTime"
                                  className="form-control"
                                  value={formData.oralExaminationTime}
                                  onChange={handleChange}
                                  placeholder="09:00 AM"
                                />
                              </div>
                              <div className="col-md-6">
                                <label className="form-label mb-1">
                                  Written Examination Time
                                </label>
                                <input
                                  type="text"
                                  name="writtenExaminationTime"
                                  className="form-control"
                                  value={formData.writtenExaminationTime}
                                  onChange={handleChange}
                                  placeholder="09:00 AM"
                                />
                              </div>
                              <div className="col-md-6">
                                <label className="form-label mb-1">
                                  Dictation Examination Time
                                </label>
                                <input
                                  type="text"
                                  name="dictationExaminationTime"
                                  className="form-control"
                                  value={formData.dictationExaminationTime}
                                  onChange={handleChange}
                                  placeholder="09:00 AM"
                                />
                              </div>

                              <div className="col-md-12 mt-3">
                                <label className="form-label mb-1 me-4">
                                  Examination Notes{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                {formData.notes.map((note, index) => (
                                  <div
                                    key={index}
                                    className="row g-2 mb-2 align-items-center"
                                  >
                                    <div className="col-md-11">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder={`Note ${index + 1}`}
                                        value={note}
                                        onChange={(e) =>
                                          handleArrayChange(
                                            "notes",
                                            index,
                                            null,
                                            e.target.value,
                                          )
                                        }
                                      />
                                    </div>
                                    <div className="col-md-1 d-flex justify-content-end">
                                      <button
                                        type="button"
                                        className="border-0 bg-danger-soft px-3 py-2 rounded-3"
                                        onClick={() =>
                                          handleRemoveRow("notes", index)
                                        }
                                      >
                                        <i className="bi bi-x-lg"></i>
                                      </button>
                                    </div>
                                  </div>
                                ))}
                                <button
                                  type="button"
                                  className="border-0 bg-info-soft px-3 py-2 rounded-3 mt-2"
                                  onClick={() => handleAddRow("notes")}
                                >
                                  <i className="bi bi-plus-lg"></i>
                                </button>
                              </div>

                              <div className="col-md-12 mt-3">
                                <label className="form-label mb-1 me-4">
                                  Result / PTM Notice{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                {formData.result.map((res, index) => (
                                  <div
                                    key={index}
                                    className="row g-2 mb-2 align-items-center"
                                  >
                                    <div className="col-md-11">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder={`Result ${index + 1}`}
                                        value={res}
                                        onChange={(e) =>
                                          handleArrayChange(
                                            "result",
                                            index,
                                            null,
                                            e.target.value,
                                          )
                                        }
                                      />
                                    </div>
                                    <div className="col-md-1 d-flex justify-content-end">
                                      <button
                                        type="button"
                                        className="border-0 bg-danger-soft px-3 py-2 rounded-3"
                                        onClick={() =>
                                          handleRemoveRow("result", index)
                                        }
                                      >
                                        <i className="bi bi-x-lg"></i>
                                      </button>
                                    </div>
                                  </div>
                                ))}
                                <button
                                  type="button"
                                  className="border-0 bg-info-soft px-3 py-2 rounded-3 mt-2"
                                  onClick={() => handleAddRow("result")}
                                >
                                  <i className="bi bi-plus-lg"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingTwo">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-controls="collapseTwo"
                            >
                              <span class="me-auto fs-5">
                                2. Oral Examination{" "}
                                <span className="ms-3 text-secondary">
                                  (05/08)
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span className="badge me-5 px-3 bg-info-soft">
                                  If Availing
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseTwo"
                            class="collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              {formData.oral.map((o, index) => (
                                <div
                                  key={index}
                                  className="row g-2 align-items-center"
                                >
                                  <div className="col-md-6">
                                    <input
                                      type="date"
                                      className="form-control"
                                      value={o.date}
                                      onChange={(e) => {
                                        const selectedDate = e.target.value;
                                        let dayName = "";

                                        if (selectedDate) {
                                          const dateObj = new Date(
                                            selectedDate,
                                          );
                                          dayName = dateObj
                                            .toLocaleDateString("en-US", {
                                              weekday: "long",
                                            })
                                            .toUpperCase();
                                        }

                                        handleArrayChange(
                                          "oral",
                                          index,
                                          "date",
                                          selectedDate,
                                        );
                                        handleArrayChange(
                                          "oral",
                                          index,
                                          "day",
                                          dayName,
                                        );
                                      }}
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      placeholder="Day"
                                      className="form-control"
                                      value={o.day}
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <Select
                                      isMulti
                                      name={`oral-subject-${index}`}
                                      value={(Array.isArray(o.subject)
                                        ? o.subject
                                        : []
                                      ).map((sub) => ({
                                        label: sub,
                                        value: sub,
                                      }))}
                                      onChange={(selected) =>
                                        handleArrayChange(
                                          "oral",
                                          index,
                                          "subject",
                                          selected && selected.length > 0
                                            ? selected.map((opt) => opt.value)
                                            : [],
                                        )
                                      }
                                      options={subjectList.map((subject) => ({
                                        label: subject,
                                        value: subject,
                                      }))}
                                      placeholder="Select Subject(s)"
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <button
                                      type="button"
                                      className="border-0 bg-danger-soft px-3 py-2 rounded-3"
                                      onClick={() =>
                                        handleRemoveRow("oral", index)
                                      }
                                    >
                                      <i className="bi bi-x-lg"></i>
                                    </button>
                                  </div>
                                </div>
                              ))}
                              <div>
                                <button
                                  type="button"
                                  className="border-0 bg-info-soft px-3 py-2 rounded-3 mt-2 w-100"
                                  onClick={() => handleAddRow("oral")}
                                >
                                  <i className="bi bi-plus-lg"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingThree">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseThree"
                              aria-controls="collapseThree"
                            >
                              <span class="me-auto fs-5">
                                3. Written Examination{" "}
                                <span className="ms-3 text-secondary">
                                  (05/08)
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span className="badge me-5 px-3 bg-danger-soft">
                                  Required
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseThree"
                            class="collapse"
                            aria-labelledby="headingThree"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              {formData.written.map((w, index) => (
                                <div
                                  key={index}
                                  className="row mb-2 g-2 align-items-center"
                                >
                                  <div className="col-md-6">
                                    <input
                                      type="date"
                                      className="form-control"
                                      value={w.date}
                                      onChange={(e) => {
                                        const selectedDate = e.target.value;
                                        let dayName = "";

                                        if (selectedDate) {
                                          const dateObj = new Date(
                                            selectedDate,
                                          );
                                          dayName = dateObj
                                            .toLocaleDateString("en-US", {
                                              weekday: "long",
                                            })
                                            .toUpperCase();
                                        }

                                        handleArrayChange(
                                          "written",
                                          index,
                                          "date",
                                          selectedDate,
                                        );
                                        handleArrayChange(
                                          "written",
                                          index,
                                          "day",
                                          dayName,
                                        );
                                      }}
                                    />
                                  </div>

                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      placeholder="Day"
                                      className="form-control"
                                      value={w.day}
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <Select
                                      isMulti
                                      name={`written-subject-${index}`}
                                      value={(Array.isArray(w.subject)
                                        ? w.subject
                                        : []
                                      ).map((sub) => ({
                                        label: sub,
                                        value: sub,
                                      }))}
                                      onChange={(selected) =>
                                        handleArrayChange(
                                          "written",
                                          index,
                                          "subject",
                                          selected && selected.length > 0
                                            ? selected.map((opt) => opt.value)
                                            : [],
                                        )
                                      }
                                      options={subjectList.map((subject) => ({
                                        label: subject,
                                        value: subject,
                                      }))}
                                      placeholder="Select Subject(s)"
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <button
                                      type="button"
                                      className="border-0 bg-danger-soft px-3 py-2 rounded-3"
                                      onClick={() =>
                                        handleRemoveRow("written", index)
                                      }
                                    >
                                      <i className="bi bi-x-lg"></i>
                                    </button>
                                  </div>
                                </div>
                              ))}
                              <div>
                                <button
                                  type="button"
                                  className="border-0 bg-info-soft px-3 py-2 rounded-3 mt-2 w-100"
                                  onClick={() => handleAddRow("written")}
                                >
                                  <i className="bi bi-plus-lg"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingFour">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseFour"
                              aria-controls="collapseFour"
                            >
                              <span class="me-auto fs-5">
                                4. Dictation Examination{" "}
                                <span className="ms-3 text-secondary">
                                  (05/08)
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span className="badge me-5 px-3 bg-info-soft">
                                  If Availing
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseFour"
                            class="collapse"
                            aria-labelledby="headingFour"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              {formData.dictation.map((d, index) => (
                                <div
                                  key={index}
                                  className="row mb-2 g-2 align-items-center"
                                >
                                  <div className="col-md-6">
                                    <input
                                      type="date"
                                      className="form-control"
                                      value={d.date}
                                      onChange={(e) => {
                                        const selectedDate = e.target.value;
                                        let dayName = "";

                                        if (selectedDate) {
                                          const dateObj = new Date(
                                            selectedDate,
                                          );
                                          dayName = dateObj
                                            .toLocaleDateString("en-US", {
                                              weekday: "long",
                                            })
                                            .toUpperCase();
                                        }

                                        handleArrayChange(
                                          "dictation",
                                          index,
                                          "date",
                                          selectedDate,
                                        );
                                        handleArrayChange(
                                          "dictation",
                                          index,
                                          "day",
                                          dayName,
                                        );
                                      }}
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      placeholder="Day"
                                      className="form-control"
                                      value={d.day}
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <Select
                                      isMulti
                                      name={`dictation-subject-${index}`}
                                      value={(Array.isArray(d.subject)
                                        ? d.subject
                                        : []
                                      ).map((sub) => ({
                                        label: sub,
                                        value: sub,
                                      }))}
                                      onChange={(selected) =>
                                        handleArrayChange(
                                          "dictation",
                                          index,
                                          "subject",
                                          selected && selected.length > 0
                                            ? selected.map((opt) => opt.value)
                                            : [],
                                        )
                                      }
                                      options={subjectList.map((subject) => ({
                                        label: subject,
                                        value: subject,
                                      }))}
                                      placeholder="Select Subject(s)"
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <button
                                      type="button"
                                      className="border-0 bg-danger-soft px-3 py-2 rounded-3"
                                      onClick={() =>
                                        handleRemoveRow("dictation", index)
                                      }
                                    >
                                      <i className="bi bi-x-lg"></i>
                                    </button>
                                  </div>
                                </div>
                              ))}
                              <div>
                                <button
                                  type="button"
                                  className="border-0 bg-info-soft px-3 py-2 rounded-3 mt-2 w-100"
                                  onClick={() => handleAddRow("dictation")}
                                >
                                  <i className="bi bi-plus-lg"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="my-3 d-flex float-end me-5">
                      <button type="submit" class="btn btn-success mt-2 px-6">
                        {loading ? (
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          ></div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
                {/* <div className="col-lg-4">
                  <div class="p-5 bg-white rounded-4 sticky-top top-10 z-1"></div>
                </div> */}
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default AddExaminationDetails;
